import React from 'react'
import './footer.css'
import {FiLinkedin} from 'react-icons/fi'
import {BsFacebook} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'

const Footer=()=> {
  const url='https://www.linkedin.com/messaging/thread/2-MjIyMDYyOTEtMjUyMS00YTU3LTgxNTAtZWFkMWFmZWM3NGU5XzAxMw==/'
  return (
    <footer>
      <a href='#' className='footer_logo'>Aman</a>
      <ul className='permalinks'>
    <li><a href='#'>Home</a></li>
    <li><a href='#about'>Experience</a></li>
    <li><a href='#services'>Services</a></li>
    <li><a href='#portfolio'>Portfolio</a></li>
    <li><a href='#testimonials'>Testimonial</a></li>
    <li><a href='#contact'>contact Me</a></li>
 </ul>
 <div className='footer_socials'>
  <a href={url}><FiLinkedin/></a>
  <a href="www.instagram.com"><BsFacebook/></a>
  <a href="www.facebook.com"><BsInstagram/></a>
 </div>
 <div className='footer_copyright'>
  <small>@copyRight;Aman Kumar</small>
 </div>
    </footer>
  )
}

export default Footer